

import React, { useEffect } from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import Button from '@material-ui/core/Button';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import InboxIcon from '@material-ui/icons/MoveToInbox';
import MailIcon from '@material-ui/icons/Mail';
import DataService from '../../../../../Service';
import { Box, FormControl, FormControlLabel, FormGroup, FormLabel, Grid, Switch, Typography } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { showSnackbar } from '../../../../../Components/Snackbar/SnackbarActions';
import CloseIcon from '@material-ui/icons/Close';

const useStyles = makeStyles({
    list: {
        width: 250,
    },
    fullList: {
        width: 'auto',
    },
    metricFilter: {
        width: 400,
        marginTop: '70px',
        padding: '10px'
    }
});

export default function MetricDrawer(props) {
    const classes = useStyles();
    const [drawerFlag, setDrawerFlag] = React.useState({ drawerFlag: false });
    const [pageData, setPageData] = React.useState([]);
    const dispatch = useDispatch();

    const toggleDrawer = (anchor, open) => (event) => {
        console.log(`anchor`, anchor, open)
        if (event && event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }

        setDrawerFlag(open);
        !open && props.parentCall(null)
    };
    console.log("props=====", props.moduleId)
    const handleChange = (e, organisationId) => {
        const formData = new FormData();
        formData.append("organisation_id", organisationId);
        formData.append("id", props.moduleId);
        formData.append("link", e.target.checked);

        var localArr = pageData.map((option) => {
            if (organisationId == option.id) {
                console.log(`organisationId`, organisationId, option.id, e.target.checked)
                option.active = e.target.checked
            }
            return option

        })

        setPageData(localArr)
        DataService.createData(formData, "add_metrics_to_organisation").then((res) => {
            dispatch(showSnackbar("Success", ["" + res.message], 5000))

        })
    }

    useEffect(() => {
        DataService.getDirectData(`/organisation_metrics/list_organisations/?id=` + props.moduleId, {}).then((res) => {
            setPageData(res.data);
        })
    }, [])

    const list = (anchor) => (
        <Box m={3} className={classes.metricFilter}>
            <Box style={{ position: "absolute", right: 30 }} >
                <CloseIcon onClick={() => props.parentCall(null)} style={{ fontSize: 18, cursor: "pointer" }} />
            </Box>
            <Typography variant="subtitle1" style={{
                marginBottom: 15, fontSize: "18px",
                fontFamily: "Open Sans"
            }}>
                <Box fontWeight="fontWeightBold">Organization metric</Box>
            </Typography>
            <FormControl component="fieldset" style={{ display: "flex" }}>
                <FormGroup>
                    {
                        pageData.map((option) => {
                            return <Box>
                                <Grid container spacing={2}>
                                    <Grid item xs={9} style={{
                                        display: "flex", alignItems: "center", fontSize: "16px",
                                        fontFamily: "Open Sans"
                                    }}>
                                        <label>{option.name}</label>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <FormControlLabel
                                            style={{ alignSelf: "flex-end" }}
                                            control={<Switch checked={option.active} onChange={(e) => handleChange(e, option.id)} name={option.name} />}
                                        />
                                    </Grid>
                                </Grid>

                            </Box>
                        })
                    }

                </FormGroup>
            </FormControl>
        </Box>
    );

    // props.parentCall(null)
    return (
        <div>
            <React.Fragment>
                <SwipeableDrawer
                    anchor={'right'}
                    open={drawerFlag}
                    onClose={toggleDrawer('drawerFlag', false)}
                    onOpen={toggleDrawer('drawerFlag', true)}
                >
                    {list('right')}
                </SwipeableDrawer>
            </React.Fragment>
        </div>
    );
}